import React from "react";

interface ResponseMessageProps {
  message: string;
  role: "admin" | "doctor";
  type?: 'success' | 'error' | 'info';
  onClose?: () => void;
}

const ResponseMessage: React.FC<ResponseMessageProps> = ({ message, role, type, onClose }) => {
  const getMessageStyles = () => {
    if (role === 'admin') {
      const messageType = type || (message.includes('Erreur') ? 'error' : 'success');
      switch (messageType) {
        case 'error':
          return 'animate-fadeIn bg-red-50 text-red-600 border border-red-200';
        case 'info':
          return 'animate-fadeIn bg-blue-50 text-blue-600 border border-blue-200';
        case 'success':
        default:
          return 'animate-fadeIn bg-green-50 text-green-600 border border-green-200';
      }
    }
    // For non-admin roles, keep the simpler styling
    const isError = type === 'error' || message.includes('Erreur');
    return isError ? 'text-red-600' : 'text-green-600';
  };

  return (
    <div className={`mt-4 p-4 rounded-lg relative ${getMessageStyles()}`}>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Fermer"
        >
          ×
        </button>
      )}
      {message}
    </div>
  );
};

export default ResponseMessage;